import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isRelatedItemRemoveWarningPopupShown, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { removeAssociatedProductAction } from '../../../redux/product/product.actions';
import { RemoveRelatedProductWarningComponent } from './remove-related-product-warning';
const productIdSelector = createSelector(popupParamsSelector, params => params === null || params === void 0 ? void 0 : params.productId);
const mapStateToProps = createStructuredSelector({
  productId: productIdSelector,
  open: isRelatedItemRemoveWarningPopupShown
});
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(hidePopup());
  },
  onSubmit: productId => {
    dispatch(removeAssociatedProductAction(productId));
  }
});
export const RemoveRelatedProductWarning = connect(mapStateToProps, mapDispatchToProps)(RemoveRelatedProductWarningComponent);